import { Employee, useEmployeeActions } from "../../modules/administration"
import { useManagerState } from "../../modules/manager"
import { NO_LOT, useLotLoaders, useProductsActions } from "../../modules/products"
import { Stock, useStockActions } from "../../modules/stock"
import { Request, RequestStatus, User, getAreaFromRole, useSystemActions, useSystemStateHooks } from "../../modules/system"
import { firstItem } from "../../utils/listUtils"
import { define } from "../../utils/typeUtils"
import { newId } from "../data-types"
import { RoutePath } from "../routes"
import { ModalId, useUIActions, useUIStateActions } from "../ui"

export const useListeners = () => {
    const { currentBranch, branches } = useManagerState()
    
    const { companyId } = useSystemStateHooks()

    const lotLoaders = useLotLoaders()

    const { setSpinnerModalMessage } = useUIStateActions()
    const systemActions = useSystemActions()
    const { removeStock } = useStockActions()
    const productsActions = useProductsActions()
    const { saveEmployee } = useEmployeeActions()
    const { openModal, closeModal, onSubmitDataType, onRemoveDataType, onArchiveDataType } = useUIActions()
    
    const onDbSubmit = (message?: string) => {
        setSpinnerModalMessage(message || 'Guardando registro...')
        openModal(ModalId.SPINNER)
    }

    const onDbSubmitDone = (createMode = true, goBack = true, routePath: RoutePath) => setTimeout(() => {
        closeModal(ModalId.SPINNER)
        onSubmitDataType(createMode, goBack, routePath)
    }, 1000)

    const onDbRemove = (message?: string) => {
        setSpinnerModalMessage(message || 'Eliminando registro...')
        openModal(ModalId.SPINNER)
    }

    const onDbRemoveDone = (showMessage = true) => setTimeout(() => {
        closeModal(ModalId.SPINNER)
        showMessage && onRemoveDataType()
    }, 1000)

    const onDbArchive = (message?: string) => {
        setSpinnerModalMessage(message || 'Archivando registro...')
        openModal(ModalId.SPINNER)
    }

    const onDbArchiveDone = () => setTimeout(() => {
        closeModal(ModalId.SPINNER)
        onArchiveDataType()
    }, 1000)

    const onUpdateStock = async (stock: Stock) => {
        if (stock.availableUnits <= 0 && stock.reservedUnits <= 0) {
            const { loadLot } = lotLoaders()
            const loadedLot = await loadLot(stock.lotId)
            if (loadedLot!.code !== NO_LOT) {
                const { removeLot } = productsActions()
                await removeLot(stock.lotId)
                return removeStock(stock.id)
            }
        }
    }

    const onEmployeeMissing = async (request: Request) => {
        if (request.status === RequestStatus.APPROVED) {
            const user = await systemActions().fetchUserById(request.userId) as User
            
            const area = getAreaFromRole(request.role)
            const branchId = currentBranch?.id || firstItem(branches)?.id
            const employee: Employee = {
                companyId: define(companyId),
                id: newId(),
                name: define(user.name || user.email),
                area: define(area),
                email: define(user.email),
                branchId: define(branchId)
            }
            
            saveEmployee(employee)
        }
    }

    return {
        onDbSubmit,
        onDbSubmitDone,
        onDbRemove,
        onDbRemoveDone,
        onDbArchive,
        onDbArchiveDone,
        onUpdateStock,
        onEmployeeMissing
    }
}
